import { apiClient, logger } from '@/lib/local-platform';
import type {
  AdminLoginReq,
  AdminLoginResp,
  ContactConfig,
  UpdateContactConfigReq,
  AdminLoginHistoryListResp,
  UpdateAdminPasswordReq,
} from '@shared/api.interface';

function getAdminHeaders() {
  const token = sessionStorage.getItem('admin_token');
  return token ? { 'x-admin-token': token } : {};
}

export async function adminLogin(data: AdminLoginReq): Promise<AdminLoginResp> {
  try {
    const response = await apiClient({
      url: '/api/admin/auth',
      method: 'POST',
      data,
    });
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status;
    if (!status || status >= 500) {
      logger.error('管理员登录失败', error);
    }
    throw error;
  }
}

export async function getAdminContactConfig(): Promise<ContactConfig> {
  const response = await apiClient({
    url: '/api/admin/contact-config',
    method: 'GET',
    headers: getAdminHeaders(),
  });
  return response.data;
}

export async function updateAdminContactConfig(data: UpdateContactConfigReq): Promise<ContactConfig> {
  const response = await apiClient({
    url: '/api/admin/contact-config',
    method: 'POST',
    data,
    headers: getAdminHeaders(),
  });
  return response.data;
}

export async function getPublicContactConfig(): Promise<ContactConfig> {
  const response = await apiClient({
    url: '/api/admin/contact-config/public',
    method: 'GET',
  });
  return response.data;
}

export async function getAdminLoginHistory(page: number = 1, pageSize: number = 20): Promise<AdminLoginHistoryListResp> {
  const response = await apiClient({
    url: '/api/admin/login-history',
    method: 'GET',
    headers: getAdminHeaders(),
    params: { page, pageSize },
  });
  return response.data;
}

export async function updateAdminPassword(data: UpdateAdminPasswordReq): Promise<{ success: boolean }> {
  const response = await apiClient({
    url: '/api/admin/password',
    method: 'POST',
    data,
    headers: getAdminHeaders(),
  });
  return response.data;
}
